import { AppState } from 'Store'

export const getPartnerIdSelector = (state: AppState) => state.auth.partner.id
